import {makeTrackEvent} from './makeTrackEvent';

export type RunMenuAction =
  | 'Rename run (project)'
  | 'Rename run (custom run name)'
  | 'Move run groups'
  | 'Delete run'
  | 'Stop run'
  | 'View run details'
  | 'Copy run name';

export type RunMenuEvent = {
  action: RunMenuAction;
  location?: 'workspace' | 'report';
};

export const trackRunMenu = makeTrackEvent<
  RunMenuEvent,
  {
    action: {
      description: 'the menu option that was selected';
    };
    location: {
      description: 'where the action was triggered from';
    };
    _description: 'Tracks run menu interactions in run selector';
    _location: 'workspaces, reports';
    _motivation: 'track usage';
  }
>('Run selector run menu');
